/* eslint-disable import/prefer-default-export */
import { MatchingNoteName } from '@marageti/z4-sdk/lib/standards';
import { ComboBoxOption } from '@marageti/z4-lib';

export const specialNotesOptions: ComboBoxOption[] = [
  {
    value: MatchingNoteName.FlexibleBudget,
    label: 'Flexible Budget',
  },
  {
    value: MatchingNoteName.RepeatTV,
    label: 'Repeat TV',
  },
  {
    value: MatchingNoteName.RepeatTVPreviousReviews,
    label: 'Repeat TV - Previous Review(s)',
  },
  {
    value: MatchingNoteName.RepeatTVBudgetTooLow,
    label: 'Repeat TV - Budget Too Low',
  },
  {
    value: MatchingNoteName.RepeatTVMinimalInformation,
    label: 'Repeat TV - Minimal Information',
  },
  {
    value: MatchingNoteName.VIPTV,
    label: 'VIP TV',
  },
  {
    value: MatchingNoteName.Special1TCMatch,
    label: 'Special - 1 TC Match',
  },
  {
    value: MatchingNoteName.Special2TCsFor1Trip,
    label: 'Special - 2 TCs for 1 Trip',
  },
  {
    value: MatchingNoteName.SpecialDecidingBetween2Destinations,
    label: 'Special - Deciding Between 2 Destinations',
  },
  {
    value: MatchingNoteName.SecondTRWithin45DaysAddTo1stTR,
    label: '2nd TR (within 45 days) - ADD to 1st TR ​​',
  },
  {
    value: MatchingNoteName.SecondTRWithin45DaysNewTR,
    label: '2nd TR (within 45 days) - new TC',
  },
  {
    value: MatchingNoteName.SecondTRWithin45DaysTVNoLongerInterested,
    label: '2nd TR (within 45 days) - TV no longer interested',
  },
  {
    value: MatchingNoteName.SimilarTRSubmittedMatchedToSameTC,
    label: 'Similar TR submitted - matched to same TC',
  },
  {
    value: MatchingNoteName.PartialTripScreened,
    label: 'Partial Trip - screened',
  },
  {
    value: MatchingNoteName.PRL,
    label: 'PRL',
  },
  {
    value: MatchingNoteName.BudgetSufficientScheduledGroupTour,
    label: 'Budget Sufficient - scheduled group tour',
  },
];

export const excludedNotes = [
  MatchingNoteName.AdditionalComments,
  MatchingNoteName.PhoneCallNotes,
];
